"use client";
import "../../Pages/Login/Login.css";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Instance from "../../Utils/Axios";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { showToast } from "../../Utils";

export default function Header() {
  const [headerData, setHeaderData] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    Instance.get("/site/header")
      .then((response) => {
        setHeaderData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setError("Error fetching header data");
        setLoading(false);
        console.error("Error fetching header data:", error);
      });
  }, []);

  // Fetch profile data if the token exists
  useEffect(() => {
    const token = localStorage.getItem("tokenId");
    if (token) {
      Instance.post("/user/profile", {
        // tokenId: token 
      })
        .then((response) => {
          setProfile(response.data.userProfile);
        })
        .catch((error) => {
          console.error("Error fetching profile data", error);
        });
    }
  }, []);

  if (error) return <div style={{ margin: "auto" }}>{error}</div>;

  if (!headerData || !headerData.logo) {
    return (
      <Navbar className="header_nav">
        <Container fluid className="header_container px-0" style={{ height: "67px" }}>
          <div className="loader" style={{ margin: "auto" }}></div>
        </Container>
      </Navbar>
    );
  }

  const renderNavItems = () => {
    return headerData.module.map((item, index) => {
      // Check for "Sign In" and "Sign Up"
      if (item.label === "SIGN UP" || item.label === "SIGN IN") {
        if (!profile) {
          return (
            <Link
              key={index}
              to={item.rUrl}
              className={item.label === "SIGN IN" ? "fill_btn" : "outline_btn"}
              onClick={() => setExpanded(false)}
            >
              {item.label}
            </Link>
          );
        } else {
          return null;
        }
      } else if (item.suboptions && item.suboptions.length > 0) {
        return (
          <NavDropdown
            key={index}
            title={item.label}
            id={`nav-dropdown-${index}`}
          >
            {item.suboptions.map((subitem, subindex) => (
              <NavDropdown.Item key={subindex} href={subitem.rUrl} onClick={() => setExpanded(false)}>
                {subitem.label}
              </NavDropdown.Item>
            ))}
          </NavDropdown>
        );
      } else {
        return (
          <Nav.Link key={index} href={item.rUrl} onClick={() => setExpanded(false)}>
            {item.label}
          </Nav.Link>
        );
      }
    });
  };

  return (
    <>
      <Navbar expanded={expanded} onToggle={setExpanded} className="header_nav">
        <Container fluid className="header_container px-0">
          <div className="">
            <img
              className="logo"
              src={headerData.logo}
              alt="Logo"
              width={147}
              height={67}
              onClick={() => {
                navigate("/customer/dashboard");
                setExpanded(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            {expanded ? (
              <div className="close-icon-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="red" viewBox="0 0 16 16">
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
              </div>
            ) : (
              <span className="navbar-toggler-icon"></span>
            )}
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav" className="mobile_menu_collapse">

            {/* LEFT SIDE MENU */}
            <Nav className="nav_items_container_login">
              {renderNavItems()}
            </Nav>

            {/* RIGHT SIDE PROFILE */}
            {profile && (
              <Nav className="ms-auto">
                <Link
                  to="/customer/profile"
                  className="user-name"
                  onClick={() => setExpanded(false)}
                >
                  {profile.firstName} {profile.lastName}
                </Link>
              </Nav>
            )}
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}
